module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "c-embed"
  }, [(_vm.title) ? _c('header', {
    staticClass: "c-embed_header"
  }, [_c('h3', {
    staticClass: "c-embed_title"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "embedElement",
    staticClass: "c-embed__content",
    style: (_vm.embedContentStyles)
  }), _vm._v(" "), (_vm.credit) ? _c('figcaption', {
    staticClass: "c-embed_credit",
    domProps: {
      "innerHTML": _vm._s(_vm.credit)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f381514"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Embed.vue
// module id = 73
// module chunks = 0